import { z } from "zod";

export const orderLineItemMatchSchema = z.object({
  id: z.number(),
  order: z.number().optional(),
  product: z.number().nullable(),
  product_name: z.string().nullable().optional(),
  product_sku: z.string().nullable(),
  original_item_name: z.string(),
  original_item_description: z.string().nullable(),
  quantity: z.union([z.string(), z.number()]).nullable(),
  unit: z.string().nullable(),
  entered_quantity: z.union([z.string(), z.number()]).nullable(),
  entered_uom: z.number().nullable(),
  normalized_quantity: z.union([z.string(), z.number()]).nullable(),
  normalized_uom: z.number().nullable(),
  applied_conversion_factor: z.union([z.string(), z.number()]).nullable(),
  is_approved: z.boolean(),
  approved_at: z.string().nullable().optional(),
  manual_override: z.boolean(),
  created_at: z.string().optional(),
  updated_at: z.string().optional(),
});

export type OrderLineItemMatch = z.infer<typeof orderLineItemMatchSchema>;

export const orderLineItemMatchesSchema = z.array(orderLineItemMatchSchema);

export const customerMatchResultSchema = z.object({
  id: z.number(),
  order: z.number(),
  erp_system: z.string(),
  search_query: z.string().nullable(),
  algorithm: z.string(),
  results: z.unknown(),
  selected_contact_id: z.string().nullable(),
  selected_contact_name: z.string().nullable(),
  manual_override: z.boolean(),
  manual_override_reason: z.string().nullable(),
  created_at: z.string(),
  updated_at: z.string(),
});

export type CustomerMatchResult = z.infer<typeof customerMatchResultSchema>;

export const customerMatchResultsSchema = z.array(customerMatchResultSchema);

export const skuMatchResultSchema = z.object({
  id: z.number(),
  order: z.number(),
  line_item: z.number(),
  erp_system: z.string(),
  line_item_index: z.number(),
  search_query: z.string().nullable(),
  algorithm: z.string(),
  results: z.unknown(),
  selected_item_id: z.string().nullable(),
  selected_item_sku: z.string().nullable(),
  selected_item_name: z.string().nullable(),
  manual_override: z.boolean(),
  manual_override_reason: z.string().nullable(),
  created_at: z.string(),
  updated_at: z.string(),
});

export type SkuMatchResult = z.infer<typeof skuMatchResultSchema>;

export const skuMatchResultsSchema = z.array(skuMatchResultSchema);
